import { Box, Typography } from '@mui/material';
import { ResponsiveLine } from '@nivo/line';
import { chartFadeSx, chartTheme, LABEL_COLOR } from '../constants';
import type { LineSeries, SeriesFilter } from '../types';
import { seriesColorsFor } from '../utils';

export const MetricsLineChart = ({
    data,
    seriesFilter,
}: {
    data: LineSeries[];
    seriesFilter: SeriesFilter;
}) => {
    const pointCount = data[0]?.data.length ?? 0;

    if (pointCount === 0) {
        return (
            <Box
                sx={{
                    height: 320,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Typography sx={{ color: LABEL_COLOR }}>No quote activity in this period</Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ height: 360, ...chartFadeSx }}>
            <ResponsiveLine
                data={data}
                margin={{ top: 28, right: 28, bottom: 56, left: 48 }}
                xScale={{ type: 'point' }}
                yScale={{ type: 'linear', min: 0, max: 'auto', stacked: false }}
                curve="monotoneX"
                colors={seriesColorsFor(seriesFilter)}
                lineWidth={2.5}
                enableArea
                areaOpacity={0.15}
                pointSize={8}
                pointColor="#fff"
                pointBorderWidth={2}
                pointBorderColor={{ from: 'seriesColor' }}
                useMesh
                enableSlices={false}
                axisBottom={{
                    tickRotation: pointCount > 10 ? -35 : 0,
                    tickSize: 0,
                    tickPadding: 10,
                }}
                axisLeft={{
                    tickSize: 0,
                    tickPadding: 10,
                    tickValues: 5,
                }}
                enableGridX={false}
                gridYValues={5}
                legends={[
                    {
                        anchor: 'top-left',
                        direction: 'row',
                        translateY: -18,
                        itemWidth: 100,
                        itemHeight: 16,
                        symbolSize: 10,
                        symbolShape: 'circle',
                    },
                ]}
                theme={chartTheme}
            />
        </Box>
    );
};
